import { DesignProp, GeneralProp } from "../PropCategories";

export const textDecoration = {
  prop: "style-attribute",
  name: "Text Decoration",
  nameI18n: "builder_ui.prop_type.styles.text_decoration",
  category: [DesignProp, GeneralProp],
  type: "select",
  defaultValue: "none",
  options: [
    {
      label: "None",
      labelI18n: "builder_ui.prop_type.styles.text_decoration_types.none",
      value: "none",
    },
    {
      label: "Underline",
      labelI18n: "builder_ui.prop_type.styles.text_decoration_types.underline",
      value: "underline",
    },
    {
      label: "Overline",
      labelI18n: "builder_ui.prop_type.styles.text_decoration_types.overline",
      value: "overline",
    },
    {
      label: "Line Through",
      labelI18n:
        "builder_ui.prop_type.styles.text_decoration_types.line_through",
      value: "line-through",
    },
  ],
} as const;
